import { GenericActivityListSort } from 'src/models/genericActivityList';
import { AbstractQuery } from 'src/models/query';

interface IdoPrintListIdoLinking {
	idoId: number;
	instanceId: number;
}

export class GetTheIdoPrintListQuery extends AbstractQuery {
	protected cacheable = false;
	name = 'IFS_DesktopModule_IDOPrint_Query_Queries_GetTheIdoPrintModuleIdoPrintsForTheIdoQuery';
	sort: Array<GenericActivityListSort> = [{ direction: 'DESC', property: 'timestamp' }];
	protected subscribeForUpdates = false;

	constructor(idoId: number, instanceId: number) {
		super();

		const idoLinkings: Array<IdoPrintListIdoLinking> = [{ idoId, instanceId }];

		this.parameters.push({
			DesktopModuleCustomFilterCondition: { idoLinkings },
		});
	}
}

export class GetTheFilledIdoPrintDocumentQuery extends AbstractQuery {
	name = 'IFS_DesktopModule_IDOPrint_Query_Queries_GetTheFilledIdoPrintDocumentQuery';

	constructor(documentId: number, instanceId: number, idoId: number, apId: number) {
		super();

		this.parameters.push({ documentId });
		this.parameters.push({ instanceId });
		this.parameters.push({ idoId });
		this.parameters.push({ apId });
	}
}
